export default __webpack_public_path__ + "static/help-1-e0722bc6cdd83e517a2384061e477aca.svg";